/* Маркер переводимой строки.
 *
 * В файлах данных вместо самого текста стоит K('scenes.s2_documents.title').
 * Маркер намеренно не знает ни про язык, ни про React: данные импортируются
 * и скриптами проверки, которым React не нужен.
 *
 * Подставляет текст hydrate() из src/i18n. */

export const TEXT_MARKER = '__t';

export const K = (key) => ({ [TEXT_MARKER]: key });

export const isTextMarker = (node) =>
  node !== null && typeof node === 'object' && typeof node[TEXT_MARKER] === 'string';
